import React, { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/teams-app-internal-analytics';

import { CardLoading } from './CardLoading';

export function CardLoadingState({ testId }: { testId: string }): React.JSX.Element {
	const { fireEvent } = useAnalyticsEvents();
	useEffect(() => {
		fireEvent('ui.userProfileCard.rendered.spinner', {});
	}, [fireEvent]);
	return <CardLoading testId={testId} />;
}
